import { useGeoServerFeaturesList } from "@l2r-front/l2r-geodata"

import { useNetworksStateContext, useRoleIsReadOnly } from "../contexts/NetworksContext"

export const useIsRoadWritable = (road: string, module: string): boolean => {

  const { selectedNetwork } = useNetworksStateContext()
  const layer = selectedNetwork?.["referential"]?.["layerSection"]

  const { data } = useGeoServerFeaturesList(`roadside:${road}`, {
    layer,
    linear_location_road: road,
  })

  const roadSubNetworks = (data ?? []).reduce((acc, feature) => {
    const subNetworks = feature?.sub_network_slugs
    if (subNetworks) {
      subNetworks.forEach((subNetwork: string) => acc.add(subNetwork))
    }
    return acc
  }, new Set<string>())

  const readOnly = useRoleIsReadOnly([...roadSubNetworks], module)

  return !readOnly
}